import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useState } from 'react';
import FaqAccordionRow from './FaqAccordionRow';
const PublicFaqList = ({ tree, activeLang, emptyMessage }) => {
    const [expandedUids, setExpandedUids] = useState(() => new Set());
    const onToggle = (uid) => {
        setExpandedUids((prev) => {
            const next = new Set(prev);
            if (next.has(uid)) {
                next.delete(uid);
            }
            else {
                next.add(uid);
            }
            return next;
        });
    };
    // Locale-aware filter. Preserves API order (CONTEXT D-14).
    const visibleCategories = [];
    for (const category of tree.categories) {
        const categoryTranslation = category.translations[activeLang];
        if (!categoryTranslation.available) {
            continue;
        }
        const visibleItems = category.items.filter((item) => item.translations[activeLang].available === true);
        if (visibleItems.length === 0) {
            continue;
        }
        visibleCategories.push({
            category,
            title: categoryTranslation.title,
            visibleItems,
        });
    }
    if (visibleCategories.length === 0) {
        return (_jsx("div", { className: "faq-empty-wrapper", children: _jsx("p", { className: "faq-empty", children: emptyMessage }) }));
    }
    return (_jsx("div", { className: "public-faq-list", children: visibleCategories.map(({ category, title, visibleItems }) => (_jsxs("section", { className: "faq-category", children: [_jsx("h2", { className: "faq-category-title", children: title }), _jsx("div", { className: "faq-category-rows", children: visibleItems.map((item) => (_jsx(FaqAccordionRow, { item: item, activeLang: activeLang, isOpen: expandedUids.has(item.uid), onToggle: onToggle }, item.uid))) })] }, category.uid))) }));
};
export default PublicFaqList;
